<template>
  <el-dialog
    append-to-body
    width="600px"
    title="查看详情"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-radio-group v-model="activeName" size="small" @change="handleTabs">
      <el-radio-button :label="1">认证信息</el-radio-button>
      <el-radio-button :label="2">简历奖励</el-radio-button>
    </el-radio-group>
    <template v-if="activeName == 1">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="姓名">{{
          userInfo.nickname
        }}</el-descriptions-item>
        <el-descriptions-item label="注册号码">{{
          userInfo.account
        }}</el-descriptions-item>
        <el-descriptions-item label="学历">{{
          userInfo.education_str
        }}</el-descriptions-item>
        <el-descriptions-item label="毕业院校">
          <div style="display: flex;align-items: center;">
          <div>{{ userInfo.school_str }}</div>
          <el-tag style="margin-left:6px" v-if="userInfo&&userInfo.college_type_str&&userInfo.college_type_str.includes('985')" size="mini" type="success">985</el-tag>
          <el-tag style="margin-left:6px" v-if="userInfo&&userInfo.college_type_str&&userInfo.college_type_str.includes('211')" size="mini" type="warning">211</el-tag>
        </div>
        </el-descriptions-item>
        <el-descriptions-item label="专业">{{
          userInfo.major_str
        }}</el-descriptions-item>
        <el-descriptions-item label="提交时间">{{
          userInfo.create_time
        }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{
          userInfo.check_time
        }}</el-descriptions-item>
      </el-descriptions>
    </template>
    <template v-else>
      <div style="margin-top: 6px">
        <div style="display: flex;
    justify-content: space-between;
    align-items: center;">
        <el-radio-group v-model="divide_type" size="mini" @change="handleTabs">
          <el-radio-button :label="0">全部</el-radio-button>
          <el-radio-button :label="4">查看奖</el-radio-button>
          <el-radio-button :label="1">下载奖</el-radio-button>
        </el-radio-group>
        <div style="font-weight: 800;">汇总:￥{{info.resume_reward}}</div>
        </div>
        <el-table :data="tableData" style="width: 100%" height="400">
          <el-table-column
            prop="company_name"
            label="公司"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="divide_type"
            label="奖励类型"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.divide_type === 1 ? "下载简历" : "查看简历" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="时间"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="amount" label="奖励金额">
            <template slot-scope="scope">￥{{ scope.row.amount }}</template>
          </el-table-column>
        </el-table>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      info: {},
      userInfo: {},
      visible: false,
      loading: false,
      activeName: 1,
      divide_type: 0,
      tableData: [],
    };
  },
  created() {},
  methods: {
    handleClick(tab) {},
    reset(done) {
      this.info = {};
      this.activeName = 1;
      this.divide_type = 0;
      this.tableData = [];
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.info = row;
      this.getUserInfo();
    },
    getUserInfo() {
      this.$http
        .get("/admin/userAuth/info", { params: { id: this.info.id } })
        .then((res) => {
          if (res.code === 1) {
            this.userInfo = res.data;
          }
        });
    },
    getUserOrder() {
      this.$http
        .get("/admin/userAuth/order", {
          params: {
            id: this.info.id,
            divide_type: this.divide_type,
            page: 1,
            count: 1000,
          },
        })
        .then((res) => {
          if (res.code === 1) {
            this.tableData = res.data.list;
          }
        });
    },
    handleTabs() {
      if (this.activeName == 2) {
        this.getUserOrder();
      }
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let params = {
            id: this.info.id,
            date: this.form.data.date,
          };
          this.$http
            .post("/admin/order/dimission", params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
